import PageLoadedQueue from "../PageLoadedQueue";

/**
 * Reset a form after it was submitted
 *
 * @param formEl
 */
export function resetFormOnSubmit(formEl: HTMLFormElement) {
    formEl.addEventListener('plandent.ajaxSubmit.submit', () => {
        formEl.reset();
    });
}

PageLoadedQueue.addFunction(() => {
    const invoiceForm = document.querySelector('form.invoice-form');
    if (invoiceForm) {
        resetFormOnSubmit(invoiceForm);
    }
    const packingSlipForm = document.querySelector('form.packing-slip-form');
    if (packingSlipForm) {
        resetFormOnSubmit(packingSlipForm);
    }
});
